import * as TYPES from './constants';
import {API} from 'config/employer.config';
import {JWT_HEADER, JSON_HEADER} from 'config/srm.config';
import {
  resolveRopInstitutionUuidList,
  appendRecruitmentInstitutionUuidListParams,
} from 'utils/employerTalentRop';
import {
  requestProgramFavoritesList,
  receiveProgramFavoritesList,
  handleProgramFavoritesListError,
} from './actions';

const initialState = {
  data: null,
  error: false,
  request: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.PROGRAM_FAVORITES_LIST_REQUEST:
      return {
        ...state,
        request: true,
      };
    case TYPES.PROGRAM_FAVORITES_LIST_RECEIVE:
      return {
        ...state,
        data: action.payload,
        request: false,
      };
    case TYPES.PROGRAM_FAVORITES_LIST_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    case TYPES.CLEAR_PROGRAM_FAVORITES_LIST:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const fetchProgramFavoritesList = (careerArea, params) => (
  dispatch,
  getState
) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    mode: 'cors',
    method: 'GET',
    cache: 'default',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
  };
  dispatch(requestProgramFavoritesList());
  const {page = 1, sort = 'date_desc', pageSize = 50, filters = []} =
    params || {};
  let URI = `${
    API.administration.program_favorites
  }?institution=true&career_area=${careerArea}&page=${page}&page_size=${pageSize}&sort=${sort}`;
  if (filters && filters.length > 0) {
    filters.forEach(filter => {
      URI += `&${filter.key}=${filter.value}`;
    });
  }

  try {
    return resolveRopInstitutionUuidList(dispatch, getState, token)
      .then(ropList =>
        fetch(appendRecruitmentInstitutionUuidListParams(URI, ropList), config)
      )
      .then(response => response.json())
      .then(json => {
        dispatch(receiveProgramFavoritesList(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleProgramFavoritesListError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleProgramFavoritesListError(err));
  }
};
